/* eslint-disable jsx-a11y/media-has-caption */
import cx from "classnames";

import styles from "./styles.module.css";
import videos from "./videos.json";

type VideoProps = {
  src?: string;
  img?: string;
  video: "dispenserHowTo" | "heroBanner" | "marketingBanner";
  height?: "full" | "three-quarters";
  autoplay?: boolean;
  controls?: boolean;
  muted?: boolean;
  loop?: boolean;
  pictureInPicture?: boolean;
  position?: "top" | "bottom" | "center";
};

export const Video = ({
  src,
  img,
  video,
  height = "three-quarters",
  controls = false,
  muted = true,
  autoplay = true,
  loop = true,
  pictureInPicture = false,
  position = "center",
}: VideoProps) => {
  let { source, image } = videos[video];

  if (src) {
    source = src;
  }

  if (img) {
    image = img;
  }

  return (
    <video
      className={cx(styles.video, styles[position], styles[height])}
      autoPlay={autoplay}
      controls={controls}
      muted={muted}
      disablePictureInPicture={pictureInPicture}
      loop={loop}
      poster={image}
      data-testid="video"
      playsInline
    >
      <source src={source} type="video/mp4" />
    </video>
  );
};
